// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.overflow-visible {
  overflow: visible;
}

ion-label {
  font-family: var(--ons-font-bold) !important;
  font-size: 14px;
  display: flex;
  align-items: center;
}
ion-label ion-icon {
  margin-left: 10px;
}

.name-input ion-label, .title-input ion-label, .description ion-label {
  font-family: var(--ons-font-light) !important;
}

ion-grid {
  padding: 0;
  padding-top: 5px;
  margin: 0 -5px;
}

ion-input {
  border-bottom: 1px solid var(--ons-color-border);
  padding-left: 5px !important;
}

ion-textarea {
  border: 1px solid var(--ons-color-border);
  padding-left: 5px;
}

.label-floating.sc-ion-label-md-h {
  color: var(--ons-color-lighter-grey);
}

app-plus-minus-input {
  margin-top: 10px;
  display: block;
}

ion-range {
  padding-top: 0;
  padding-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
  --bar-background-active: var(--ons-color-primary);
}
ion-range::part(pin) {
  font-size: 15px;
  transform: translate3d(0px, 0px, 0px) scale(1);
  top: 45px;
  position: absolute;
  left: 0;
  width: 100%;
}

.range-pins {
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
}
.range-pins .range-pin {
  white-space: nowrap;
}

.ons-tags {
  padding: 0;
}
.ons-tags ion-icon {
  color: var(--ons-color-primary-black);
}

.description-input {
  display: flex;
  align-items: center;
}
.description-use-template {
  width: 50px;
  height: 112px;
  padding-top: 4px;
  padding-left: 10px;
}

ion-icon {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/training-unit/training-unit.component.scss"],"names":[],"mappings":"AACA;EACI,iBAAA;AAAJ;;AAGA;EACI,4CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AAEI;EACI,iBAAA;AAAR;;AAKI;EACI,6CAAA;AAFR;;AAMA;EACI,UAAA;EACA,gBAAA;EACA,cAAA;AAHJ;;AAMA;EACI,gDAAA;EACA,4BAAA;AAHJ;;AAMA;EACI,yCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,cAAA;AAHJ;;AAMA;EACI,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iDAAA;AAHJ;AAKI;EACI,eAAA;EACA,8CAAA;EACA,SAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;AAHR;;AAOA;EACI,aAAA;EACA,8BAAA;EACA,eAAA;AAJJ;AAMI;EACI,mBAAA;AAJR;;AAQA;EACI,UAAA;AALJ;AAOI;EACI,qCAAA;AALR;;AAWI;EACI,aAAA;EACA,mBAAA;AARR;AAWI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AATR;;AAcA;EACI,eAAA;AAXJ","sourcesContent":["\nion-item.overflow-visible {\n    overflow: visible;\n}\n\nion-label {\n    font-family: var(--ons-font-bold) !important;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n\n    ion-icon {\n        margin-left: 10px;\n    }\n}\n\n.name-input, .title-input, .description {\n    ion-label {\n        font-family: var(--ons-font-light) !important;\n    }\n}\n\nion-grid {\n    padding: 0;\n    padding-top: 5px;\n    margin: 0 -5px;\n}\n\nion-input {\n    border-bottom: 1px solid var(--ons-color-border);\n    padding-left: 5px !important;\n}\n\nion-textarea {\n    border: 1px solid var(--ons-color-border);\n    padding-left: 5px;\n}\n\n.label-floating.sc-ion-label-md-h {\n    color: var(--ons-color-lighter-grey);\n}\n\napp-plus-minus-input {\n    margin-top: 10px;\n    display: block;\n}\n\nion-range {\n    padding-top: 0;\n    padding-bottom: 20px;\n    padding-left: 30px;\n    padding-right: 30px;\n    --bar-background-active: var(--ons-color-primary);\n\n    &::part(pin) {\n        font-size: 15px;\n        transform: translate3d(0px, 0px, 0px) scale(1);\n        top: 45px;\n        position: absolute;\n        left: 0;\n        width: 100%;\n    }\n}\n\n.range-pins {\n    display: flex;\n    justify-content: space-between;\n    padding: 0 16px;\n\n    .range-pin {\n        white-space: nowrap;\n    }\n}\n\n.ons-tags {\n    padding: 0;\n\n    ion-icon {\n        color: var(--ons-color-primary-black);\n    }\n}\n\n.description{\n    \n    &-input{\n        display: flex;\n        align-items: center;\n    }\n\n    &-use-template{\n        width: 50px;\n        height: 112px;\n        padding-top: 4px;\n        padding-left: 10px;\n    }\n\n}\n\nion-icon {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
